import { OTelPrimaryIdentitySpace, } from '@1js/ai-hub-telemetry';
import { getOneDsEndpoint, getReleaseAudienceGroup, } from '@office-start/otel-telemetry-service';
import { getParamFromWindow } from '@office-start/window-utility';
export function generateAppVersion(bundleBuildId, bundleBuildDate) {
    var VERSION = bundleBuildId;
    var buildDate = bundleBuildDate.split(' ')[0].split('-').join('');
    var appVersion = [buildDate, VERSION].join('.');
    return appVersion;
}
export function isDevMode() {
    var _a, _b;
    var qsp = new URLSearchParams(window.location.search);
    var flightsParam = (_b = (_a = qsp.get('flight')) === null || _a === void 0 ? void 0 : _a.toLocaleLowerCase()) === null || _b === void 0 ? void 0 : _b.split(',');
    return flightsParam ? flightsParam === null || flightsParam === void 0 ? void 0 : flightsParam.includes('localbundles') : false;
}
export function createAiHubOtelConfig(config) {
    var _a;
    var idSpace = (config === null || config === void 0 ? void 0 : config.isMsa)
        ? OTelPrimaryIdentitySpace.MSAPUID
        : OTelPrimaryIdentitySpace.OrgIdPUID;
    var appVersion = generateAppVersion(config.bundleBuildId, config.bundleBuildDate);
    var devMode = isDevMode();
    var releaseAudienceGroup = getReleaseAudienceGroup(config.deploymentEnvironment, config.isCorpNet, getParamFromWindow('testtraffic') === '1' || devMode);
    var endpointUrl = getOneDsEndpoint(config.deploymentEnvironment, config.dataBoundary, config.isEudbEndpointEnabled);
    var aiHubOtelConfig = {
        customEndpointUrl: endpointUrl,
        partAConfig: {
            coreFields: {
                session: { id: config.sessionId },
                app: {
                    name: config.appName,
                    platform: config.appPlatform,
                    version: appVersion,
                },
                user: {
                    tenantId: config.tenantId,
                    primaryIdentityHash: config.puid,
                    isAnonymous: false,
                    primaryIdentitySpace: idSpace,
                    tenantGroup: (config === null || config === void 0 ? void 0 : config.isMsa) ? 'Consumer' : 'Commercial',
                },
                release: { audienceGroup: releaseAudienceGroup },
            },
            userInfo: { language: (_a = config.preferredCulture) !== null && _a !== void 0 ? _a : 'unknown' },
            ecsRing: config.ecsRing,
            devMode: devMode,
            browserSessionId: config.browserSessionId,
            dataBoundary: config.dataBoundary,
            deploymentEnvironment: config.deploymentEnvironment,
            isEudbEndpointEnabled: config.isEudbEndpointEnabled,
            flights: config.flights,
            userSegment: config.userSegment,
        },
        partCConfig: {
            appConfiguration: config.rootPath,
        },
    };
    return aiHubOtelConfig;
}
//# sourceMappingURL=createAiHubOtelConfig.js.map